import Loading from "@@/core/components/shared/Loading/Loading";
import mixins from "@@/core/mixins/mixins";
import FormModal from "@@/core/libraries/form/FormModal";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import moment from "moment-jalaali";
import Back from "@@/core/components/shared/Back/Back";
import {
  BButton,
  BCard,
  BCollapse,
  BFormGroup,
  BFormInput,
  BTable,
  BTooltip,
  VBToggle,
} from "bootstrap-vue";
import { forEach } from "lodash";
export default {
  name: "ConstractionCreate",
  components: {
    FormModal,
    Loading,
    BTooltip,
    BButton,
    BCollapse,
    BCard,
    BFormGroup,
    BFormInput,
    BTable,
    ProductSearch,
    Back,
  },
  directives: {
    "b-toggle": VBToggle,
  },
  mixins: [mixins],
  data() {
    return {
      productSelect: null,
      stores: [],
      varietySelect: null,
      Store: null,
      fromStore: null,
      isButtonDisabled: false,
      varieties: [],
      productSku: "",
      // refund: false,
      itemsRequested: null,
    };
  },
  mounted() {
    this.loadStores();
    this.focusProductSku();
  },
  watch: {
    fromStore(newValue, oldValue) {
      if (oldValue && newValue && newValue.id !== oldValue.id) {
        this.varieties = [];
        this.$root.notify("با تغییر انبار، محصولات قبلی حذف شدند", "warning");
      }
    },
  },
  methods: {
    focusProductSku() {
      this.$nextTick(() => {
        if (this.$refs.productSku) {
          this.$refs.productSku.focus();
        }
      });
    },
    async loadStores() {
      try {
        const response = await this.$axios.get("admin/stores");
        this.stores = response.data.data.stores;
      } catch (e) {
        this.$root.notify(e);
      }
    },
    async requestProduct() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/mini_orders/search", {
          params: {
            sku: this.productSku,
            // refund: this.refund,
          },
        });
        const variety = response.data.data.variety;
        this.addVariety(variety);
        this.productSku = "";
        const existing = this.varieties.find((v) => v.id === variety.id);
        if (existing) {
          this.$root.notify(
            " این محصول قبلاً اضافه شده است به تعداد درخواستی یک عدد اضافه شد.",
            "success",
          );
          this.focusProductSku();
          return;
        }
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        if (this.productSku === "") {
          // اگر درخواست موفق بود و sku پاک شد، باید فوکوس کنیم.
          this.focusProductSku();
        }
      }
    },
    selectVariety(variety) {
      this.addVariety(variety);
    },
    addVariety(variety) {
      if (!this.fromStore) {
        this.$root.notify("ابتدا انبار را انتخاب کنید", "warning");
        return;
      }
      // جلوگیری از تکرار محصول
      const existing = this.varieties.find((v) => v.id === variety.id);
      if (existing) {
        existing.requestedQuantity += 1;
      } else {
        // اضافه شدن محصول جدید
        this.varieties.push({
          ...variety,
          requestedQuantity: 1, // مقدار پیش‌فرض
          store_name: this.fromStore.name,
        });
      }
    },
    deleteItem(index) {
      this.varieties.splice(index, 1);
    },
    async submitData() {
      this.isButtonDisabled = true;
      if (!this.fromStore) {
        this.$root.notify("انبار انتخاب نشده است", "warning");
        return;
      }
      const data = {
        store_id: this.fromStore.id,
        varieties: this.varieties.map((variety) => ({
          id: variety.id,
          quantity: variety.requestedQuantity, // 🔸 مقدار درست از input
        })),
      };
      try {
        const response = await this.$axios.post(
          "admin/store-contradictions",
          data,
        );
        this.$root.notify(response.data.message, "success");
      } catch (error) {
        this.$root.notify(error);
      }
      this.isButtonDisabled = false;
      this.$router.back();
    },
  },
};
